import { Avatar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { stringAvatar } from 'src/utils';
import { generateCompanyLogoAvatarSrc } from 'src/utils/companyLogo';
import { CompanyDocument } from 'types';

interface OpportunitiesCardTitleProps {
	companyImg: string;
	companyName: string;
	positionTitle: string;
	companyUrl: string;
}

const OpportunitiesCardTitle: React.FC<OpportunitiesCardTitleProps> = ({
	companyImg,
	companyName,
	positionTitle,
	companyUrl,
}) => {
	const [avatarImg, setAvatarImg] = useState('');
	const generateAvatar = async (data: CompanyDocument) => {
		const res = await generateCompanyLogoAvatarSrc(data?.logo || '', data?.url || '');
		setAvatarImg(res);
	};

	useEffect(() => {
		generateAvatar({ logo: companyImg, url: companyUrl } as CompanyDocument);
	}, [companyImg, companyUrl]);

	return (
		<div className="max-w-[627px] flex flex-start gap-[8px]">
			<div className="flex justify-center items-center text-center min-w-[48px] min-h-[48px] max-w-[48px] max-h-[32px] rounded-full border border-[#F3F2F2]">
				<Avatar
					src={avatarImg}
					alt="companyLogo"
					sx={{ width: '38px', height: '38px', minWidth: '38px', minHeight: '38px', fontSize: '12px' }}
				>
					{stringAvatar(companyName?.trim()?.toUpperCase() || '')}
				</Avatar>
			</div>
			<div className="md:max-w-[627px] md:w-full">
				<h6 className="text-[#28293D] font-inter text-[18px] font-[600] leading-[28px]">{positionTitle}</h6>
				<a
					target="_blank"
					href={companyUrl}
					className="flex gap-2 text-[#28293D] items-center text-[14px] font-inter font-[500] leading-[20px]"
				>
					{companyName} <FiExternalLink color="#6698FA" />
				</a>
			</div>
		</div>
	);
};

export default OpportunitiesCardTitle;
